import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './page-leave-confirmation.reducer';
import { pageLeaveConfirmationFeatureName } from './page-leave-confirmation.feature';

export const getState = createFeatureSelector<State>(pageLeaveConfirmationFeatureName);

export const isEnabled = createSelector(getState, (state: State): boolean => state.enabled);
